<style type="text/css" scoped>
.login_card {
  width: 476px;
  gap: 32px;
  border-radius: 4px;
  padding: 48px;
  box-shadow: 0px 4px 9.6px 0px #0000000A;
}

.login__tec_txt {
  font-weight: 400;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000000;
}

.email_user_pwd_id_txt {
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: Title Large/Tracking;
  color: #3F4254;
}

._required_txt {
  font-weight: 400;
  font-size: Label Medium/Size;
  line-height: Label Medium/Line Height;
  letter-spacing: Label Medium/Tracking;
  color: #F1416C;
}

.forgot_txt {
  font-weight: 400;
  font-size: 12px;
  line-height: Label Medium/Line Height;
  letter-spacing: 0.5px;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-offset: 0%;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  color: #777490;
  display: flow;
  text-align: end;
  cursor: pointer;
}

.don_t_acc {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-align: center;
  color: #777490;
}

.create_acc_txt {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-offset: 0%;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  color: #FFA500;
}

.or_txt {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.5px;
  color: #777490;
  text-align: center;
}

.login_background {
  background: #ffffff;
}

.responsive-image {
  width: 111px;
  height: 39px;
  max-width: 380px;
  /* Set a maximum width to avoid the image stretching too large */
}

.board-cls {
  font-family: "poppins" !important;
  font-weight: 400;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0%;

}
</style>
<style>
/* .custom-input_bp.v-text-field--outlined fieldset {
  color: #FFF7F2 !important;
} */
.custom-input_bp.v-text-field--outlined fieldset {
  border-color: #FFF7F2 !important;
  /* Default border color */
  color: #FFF7F2 !important;
  /* Label color */
}

.custom-input_bp.v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #ffa500 !important;
  /* Border color when focused */
}

.custom-input_bp ::placeholder {
  font-family: "poppins" !important;
  font-size: 14px;
  color: #777490 !important;
  font-weight: 400;
  letter-spacing: 0.5px;
}
</style>
<template>
  <v-app style="margin-top: 0px !important;">
    <v-overlay :value="overlay_load" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container class="fill-height login_background" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="login_card pa-6" elevation="2">
            <section class="pa-5">

              <section class="d-flex align-center">
                <img height="132" width="380" src="@/assets/Board_Login.png" alt="Board Login"
                  class="responsive-image" />
                <div class="ml-4">
                  <h2 class="board-cls">Login to BoardPAGE</h2>
                </div>
              </section>


              <section class="pt-16">
                <div class="email_user_pwd_id_txt">Email or Username <span class="_required_txt">*</span></div>
                <v-text-field v-model="email" placeholder="Enter your email or username" outlined
                  @keypress.enter="$refs[`indx_of_pwd`].focus()" color="#ffa500" class="pt-2 custom-input_bp">
                </v-text-field>


                <div class="email_user_pwd_id_txt">Password <span class="_required_txt">*</span></div>
                <v-text-field v-model="password" :type="showPassword ? 'text' : 'password'"
                  placeholder="Enter your Password" outlined ref="indx_of_pwd"
                  @keypress.enter="prefixflag ? $refs[`indx_of_perfix`].focus() : validate()" hide-details
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword"
                  color="#ffa500" class="pt-2 custom-input_bp">
                </v-text-field>
                <!-- <div class="forgot_txt pt-1" @click="forgot">Forgot Password?</div> -->
                <div style="text-align: end"><span class="forgot_txt pt-1" @click="forgot"
                    style="display: inline;">Forgot Password?</span> </div>

                <template v-if="prefixflag">
                  <div class="email_user_pwd_id_txt">Sub Domain<span class="_required_txt">*</span></div>
                  <v-text-field v-model="prefix" placeholder="Sub Domain" outlined ref="indx_of_perfix"
                    @keypress.enter="validate()" class="pt-2 custom-input_bp">
                  </v-text-field>
                </template>

              </section>


              <v-btn class="mt-6 pa-6" dark block color="#FFA500" @click="validate()" @keyup.enter="validate()"
                elevation="2"> <span style="text-transform: capitalize;">login</span>
              </v-btn>
              <!-- <div class="don_t_acc pt-6">Don’t have an account? <span class="create_acc_txt">Contact your admin.</span>
              </div> -->
              <!-- <div class="or_txt pt-6">Or</div> -->

              <!--  <section class="px-16 pt-6 d-flex justify-space-between">
                <img height="16" width="16" src="../assets/google.svg" /> 
                <img height="16" width="16" src="../assets/microsoft.svg" /> 
                <img height="16" width="16" src="../assets/apple.svg" /> 
              </section> -->

            </section>

          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Package from "/package.json";
export default {
  mounted: function () {
    // 🚨🚨 IMPORTANT NOTICE 🚨🚨
    // Any change here REQUIRES updating the file below
    // import { handleLogin } from '@/Services/loginHelper.js';
    console.log('%c🚨🚨 IMPORTANT NOTICE 🚨🚨', 'color: red; font-size: 20px; font-weight: bold;');
    console.log('%cAny change here REQUIRES updating the file below', 'color: #d32f2f; font-size: 18px; font-weight: 600;');
    console.log('%cimport { handleLogin } from \'@/Services/loginHelper.js\';', 'color: #1565c0; font-size: 16px; font-weight: 500;');

    let domain = window.location.host.split(".");
    if (domain.length === 0 || domain == null || domain == "" || domain == undefined || domain == "localhost") {
      this.prefixflag = true;
    }
  },
  data() {
    return {
      applicationVersion: Package.version,
      resultats: null,
      btn: true,
      background: null,
      background_color: "bg",
      card_color: "cardblue",
      login: "login",
      button: "button",
      not: "not",
      forgo: "forgo",
      email: "",
      password: "",
      valid: "",
      domain: "",
      showPassword: false,
      overlay_load: false,
      step: null,
      show_hide_mob_btn: 0,
      full_or_modal: 0,
      window: {
        width: 0,
        height: 0,
      },
      emailRules: [
        (v) => !!v || "E-mail is required", (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/.test(v) ||
          // /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      checkbox: false,
      mini: false,
      showimage: false,
      window: {
        width: 0,
        height: 0,
      },
      iflag: 0,
      prefix: null,
      prefixflag: false,
      logged_user_id: null,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.back();
    // this.resultats = JSON.parse(localStorage.getItem("resultat") || "");
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    this.back();
  },
  methods: {
    update_user_data() {
      let prefix = "cmp_" + this.prefix;
      prefix = prefix == 'cmp_admin' ? 'public' : prefix;
      const user_dataset = {
        user_dataset: {
          logged_date: moment(),
          expiry_date: moment().add(7, "days")
        }
      }
      this.$api.put("/update_user_logged_data/" + this.logged_user_id + "/" + prefix, user_dataset).then((response) => {
        let expiry_date = moment().add(7, "days").format("YYYY-MM-DD");
        // console.log(expiry_date, "expiry_date");
        localStorage.setItem("expiry_date", expiry_date);
        const name = localStorage.getItem("expiry_date");
        // console.log(name, "name");
      }).catch((error) => {
        console.log(error, "error");
        this.global_push_toast("error", `${error.response.status} - ${error.response.statusText}`);
      });
    },
    back() {
      // console.log(this.btn,"this.btn");
      if (this.btn) {
        this.btn = false;
        this.background_color = "bg";
        this.card_color = "cardblue";
        this.login = "login";
        this.button = "button";
        this.not = "not";
        this.forgo = "forgo";
        // this.background = 'bg1'
      } else {
        this.btn = true;
        this.background_color = "bg1";
        this.card_color = "cardwhite";
        this.login = "login1";
        this.button = "button1";
        this.not = "not1";
        this.forgo = "forgo1";
        // this.background = 'bg'
      }
    },
    // handleResize() {
    //   this.window.width = window.innerWidth;
    //   this.window.height = window.innerHeight;
    //   if (this.window.width <= 576) {
    //     this.showimage = true;
    //   } else {
    //     this.showimage = false;
    //   }
    // },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width <= 576) {
        this.show_hide_mob_btn = 2;
        this.full_or_modal = 1;
      } else {
        this.show_hide_mob_btn = 1;
        this.full_or_modal = 0;
      }
    },
    validate() {
      if (this.prefixflag) {
        if (!this.prefix) {
          return;
        }
      } else {
        let domain = window.location.host.split(".");
        // console.log(domain, "domain local");
        this.prefix = domain[0];
      }
      this.overlay_load = true;
      window.axios = require("axios");
      let mail = this.email;
      if (mail) {
        mail = mail.trim();
      }
      let pass_word = this.password;
      if (pass_word) {
        pass_word = pass_word.trim();
      }
      const login_dataset = {
        email: mail,
        password: pass_word,
        prefix: "cmp_" + this.prefix,
      };
      axios.post("api/sessions/login", login_dataset).then((response) => {
        // 🚨🚨 IMPORTANT NOTICE 🚨🚨
        // Any change here REQUIRES updating the file below
        // import { handleLogin } from '@/Services/loginHelper.js';
        console.log('%c🚨🚨 IMPORTANT NOTICE 🚨🚨', 'color: red; font-size: 20px; font-weight: bold;');
        console.log('%cAny change here REQUIRES updating the file below', 'color: #d32f2f; font-size: 18px; font-weight: 600;');
        console.log('%cimport { handleLogin } from \'@/Services/loginHelper.js\';', 'color: #1565c0; font-size: 16px; font-weight: 500;');
        this.Successdataset(response.data, this.prefix);
      }).catch((error) => {
        console.log(error);
        this.overlay_load = false;
        this.global_push_toast("error", "server error");
      });
    },
    Successdataset(data, domain) {
      // console.log(data, "result");
      // localStorage.post(this.applicationVersion)
      // this.resultats.push(this.applicationVersion)
      localStorage.setItem("resultat", this.applicationVersion);
      if (data.result == "success") {
        localStorage.setItem("TOKEN", data.token);
        let features_list = [];
        let product_list = [];
        let entitydata = [];
        if (!["admin", "devadmin"].includes(domain)) {
          // console.log(domain, " = domain");
          axios.get("tapi/get_features_by_role/" + data.user_id).then((response) => {
            // console.log(response.data,'get_features_by_role')
            if (response.data.data[0].entity_list.length == 0) {
              this.overlay_load = false;
              alert("Client is Deactivated");
              localStorage.clear();
              return;
            }

            // Clear host dialog flag to ensure dialog can show if needed
            sessionStorage.removeItem("host_dialog_shown");

            this.getDomainLogo(domain);
            localStorage.setItem("entitydata", JSON.stringify(response.data.data[0].entity_list));
            let enty = response.data.data[0].entity_list;
            if (enty.length == 1) {
              localStorage.setItem("ENTITY_ID", enty[0].id);
              localStorage.setItem("entity_name", enty[0].name);
              localStorage.setItem("ENT_FINYEAR", enty[0].financial_year != null ? enty[0].financial_year : "__NA__");
            }

            localStorage.setItem("family_office_flag", response.data.data[0].family_office_flag);
            localStorage.setItem("family_tree_flag", response.data.data[0].family_tree_flag);
                
            let employee_dataset = response.data.emp_details;
            localStorage.setItem("Self_Rating_Setting", "yes");
            let content_binary = null;
            if (employee_dataset.length) {
              localStorage.setItem("LOGGED_EMP_ID", employee_dataset[0].id);
              localStorage.setItem("LOGGED_EMP_NO", employee_dataset[0].empno);


              for (let j = 0; j < employee_dataset.length; j++) {
                let d = employee_dataset[j].profile_pic || [];
                if (d.length) {
                  if (d[0]?.content_binary) {
                    content_binary = d[0]?.content_binary;
                  }
                }
              }
            } else {
              localStorage.setItem("LOGGED_EMP_ID", 0);
              localStorage.setItem("LOGGED_EMP_NO", 0);
            }
            if (content_binary) {
              localStorage.setItem("LOGGED_EMP_PROFILE_IMG", content_binary);
            } else {
              localStorage.setItem("LOGGED_EMP_PROFILE_IMG", require('@/assets/Menu/Empty_Profile_Pic.jpg'));
            }
            localStorage.setItem("APPRAISAL_PERIOD_MSTR", JSON.stringify(response.data.appraisal_period_mstr));


            let fl = response.data.data[0].roles_list;
            this.set_local_storage(response.data.modules_by_users, response.data.screen_by_users);
            // products_by_users
            let pl = [];
            let product_list_item = response.data.products_by_users;
            if (product_list_item.length != 0) {
              pl = product_list_item.map((a) => a.product_code);
            } else {
              pl = response.data.data[0].product_list;
            }
            if (fl == "" || fl == null) {
              features_list = [];
            } else {
              features_list = fl;
            }
            if (pl == "" || pl == null) {
              product_list = [];
            } else {
              product_list = pl;
            }
            

            // console.log(product_list, 'product_list')
            localStorage.setItem("tectalik_product_list", product_list);
            localStorage.setItem("features_list", features_list);
            localStorage.setItem("USER_ID", data.user_id);
            this.logged_user_id = data.user_id;
            localStorage.setItem("USER_EMAIL", data.user_email);
            localStorage.setItem("USER_NAME", data.user_name);
            localStorage.setItem("BRANCH_ID", response.data.data[0].branch_id);
            var product_get = localStorage.getItem("tectalik_product_list");
            localStorage.setItem("domain", domain);
            product_list = [];
            if (product_get != null && product_get != "" && product_get != undefined && product_get.length != 0) {
              product_list = product_get.split(",");
            }

            if (response.data.data) {
              console.log(response.data.data[0], "response.data.data[0]");
              localStorage.setItem("CHAIRMAN_FLAG", response.data.data[0].chairman_flag);
              localStorage.setItem("CEO_FLAG", response.data.data[0].ceo_flag);
              localStorage.setItem("SECRETARY_FLAG", response.data.data[0].secretary_flag);
              localStorage.setItem("USER_DESIGNATION", response.data.data[0].designation_name);
              localStorage.setItem("DEPT_ID", response.data.data[0].department_id || "");
            } else {
              localStorage.setItem("CHAIRMAN_FLAG", false);
              localStorage.setItem("CEO_FLAG", false);
              localStorage.setItem("SECRETARY_FLAG", false);
              localStorage.setItem("USER_DESIGNATION", '');
              localStorage.setItem("DEPT_ID", "");
            }
            const doRedirect = () => {
              if (response.data.data[0].chairman_flag == true || response.data.data[0].ceo_flag == true) {
                this.$router.push({ path: "/BoardDashBoard" });
              } else if (response.data.data[0].secretary_flag == true) {
                this.$router.push({ path: "/SecretaryBoard" });
              } else {
                this.$router.push({ path: "/scorecard_new" });
              }
            };

            const entityId = parseInt(localStorage.getItem("ENTITY_ID") || enty[0].id);
            axios.get("setup_guide/progress", { params: { entity_id: entityId } })
              .then(sgRes => {
                if (sgRes.data.data.length === 0) {
                  this.$router.push({ path: "/setup_guide" });
                } else {
                  doRedirect();
                }
              })
              .catch(() => doRedirect());
          }).then(() => {})
          // this.requestPermission())
          .catch((error) => console.log(error, "error"));
        } else {
          axios.get("api/get_screen_and_user_data_by_role/", {
            params: {
              user_id: data.user_id,
            },
          }).then((response) => {
            // console.log(response.data.common_screen_dataset,'get_screen_and_user_data_by_role')
            localStorage.setItem("USER_TYPE", response.data.data.user_type_code);
            localStorage.setItem("USER_TYPES", response.data.data.user_type_code);
            let screen_dataset = [];
            let module_dataset = [];
            localStorage.setItem("SCREEN_RIGHT_DATASET", JSON.stringify(screen_dataset));
            localStorage.setItem("MODULE_RIGHTS_DATASET", JSON.stringify(module_dataset));
            let common_screen_dataset = response.data.common_screen_dataset;
            localStorage.setItem("COMMON_SCREEN_RIGHT_DATASET", JSON.stringify(common_screen_dataset));
            localStorage.setItem("tectalik_product_list", product_list);
            localStorage.setItem("features_list", features_list);
            localStorage.setItem("TOKEN", data.token);
            localStorage.setItem("USER_ID", data.user_id);
            this.logged_user_id = data.user_id;
            localStorage.setItem("USER_EMAIL", data.user_email);
            localStorage.setItem("USER_NAME", data.user_name);
            localStorage.setItem("domain", domain);
            this.$router.push({
              path: "/admin_landing",
            });
          }).then(() => {})
            // this.requestPermission()
          .catch((error) => {
            this.overlay_load = false;
            alert("Invalid credentails");
            return;
          });
        }
      } else {
        this.overlay_load = false;
        alert("Invalid credentails");
        return;
      }
    },
    async getDomainLogo(domain) {
      try {
        const res = await this.$papi.get("get_domain_logo_by_domain", {
          params: { domain: domain },
        });
        if (res.data.data && res.data.data.logo) {          
          let logoUrl = null;
          // Check if the logo URL is already a full URL
          if (res.data.data.logo.startsWith('https://')) {
            logoUrl = res.data.data.logo;
          } else {
            // If it's a relative path, construct the full URL
            logoUrl = `https://devcdn.tectalik.com/compliance/uploads/original_${res.data.data.logo}`;
            localStorage.setItem("logoUrl", logoUrl);
          }
        } else {
        }
      } catch (err) {
        console.error("Error fetching logo:", err);
      }
    },
    forgot() {
      let domain = window.location.host.split(".");
      if (domain[0] == "admin") {
        this.$router.push({
          path: "/forgotpassword_admin?email=" + this.email,
        });
      } else {
        this.$router.push({
          path: "/forgotpassword?email=" + this.email
        });
      }
    },
    set_local_storage(module_dataset = [], screen_dataset = []) {
      localStorage.setItem("MODULE_RIGHTS_DATASET", JSON.stringify(module_dataset));
      for (let i = 0; i < screen_dataset.length; i++) {
        screen_dataset[i]["hide_all"] = false;
        screen_dataset[i]["module_name"] = false;
        for (let j = 0; j < module_dataset.length; j++) {
          if (screen_dataset[i].modules_rights_id == module_dataset[j].id) {
            screen_dataset[i]["hide_all"] = module_dataset[j].active;
            screen_dataset[i]["module_name"] = module_dataset[j].module_name;
          }
        }
      }
      localStorage.setItem("SCREEN_RIGHT_DATASET", JSON.stringify(screen_dataset));
    },
    changetoLowercase($subdomain) {
      this.prefix = $subdomain.toLowerCase().trim();
      // console.log(this.prefix,"$prefix");
    },
  },
}; 
</script>